export default "assets/images/icons/twitter-a431a521.svg";